export default function IconSqftUltimate() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			id="Real-Estate-Dimensions-House-Ruler--Streamline-Ultimate"
			height="100%"
			width="100%"
		>
			<desc>{'\n    Real Estate Dimensions House Ruler Streamline Icon: https://streamlinehq.com\n  '}</desc>
			<g>
				<path
					d="M21.5 15v7.5a1 1 0 0 1 -1 1h-9a1 1 0 0 1 -1 -1V15"
					fill="none"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={1}
				/>
				<path
					d="m8.5 17 7.15 -7.15a0.5 0.5 0 0 1 0.7 0L23.5 17"
					fill="none"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={1}
				/>
				<path
					d="M5.5 5.5h-5V23a0.5 0.5 0 0 0 0.5 0.5h4a0.5 0.5 0 0 0 0.5 -0.5Z"
					fill="none"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={1}
				/>
				<path
					d="M23 5.5a0.5 0.5 0 0 0 0.5 -0.5V1a0.5 0.5 0 0 0 -0.5 -0.5H5.5v5Z"
					fill="none"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={1}
				/>
				<path
					d="M0.5 5.5V1A0.5 0.5 0 0 1 1 0.5h4.5"
					fill="none"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={1}
				/>
				<path d="m8.5 5.5 0 -2" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
				<path d="m12.5 5.5 0 -2" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
				<path d="m16.5 5.5 0 -2" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
				<path d="m20.5 5.5 0 -2" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
				<path d="m5.5 20.5 -2 0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
				<path d="m5.5 16.5 -2 0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
				<path d="m5.5 12.5 -2 0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
				<path d="m5.5 8.5 -2 0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
				<path
					d="M17.5 23.5v-4a1.5 1.5 0 0 0 -3 0v4"
					fill="none"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={1}
				/>
			</g>
		</svg>
	);
}
